/*LIBRARY*/
import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import MAP_EDITOR from "../../Components/editor_map/MAP_EDITOR";
import NO_LICENSE_HANDLE from "../../Components/blocked_page/NO_LICENSE_HANDLE";
import COLLAB_BLOCK_VIEWER from "../../Components/blocked_page/COLLAB_BLOCK_VIEWER";
import COLLAB_BLOCK_EDITOR from "../../Components/blocked_page/COLLAB_BLOCK_EDITOR";

import icon_geomapid from "../../Assets/svg/icon_geomapid.svg";

/*REDUX*/
import {
  clearProject,
  get_project_only,
} from "../../App/actions/projectActions";
import {
  set_value_properties,
  get_detail_many_layer,
} from "../../App/actions/propertiesActions";
import { finishGenangan } from "../../App/actions/layerNewActions";
import { getDetailLayerById } from "../../App/actions/get_features_action";
import { clearLayer, realtime_update } from "../../App/actions/layerActions";
import { getUserPaymentList } from "../../App/actions/paymentActions";
import { getGroups, getGroupsProject } from "../../App/actions/groupActions";
import { set_value_user } from "../../App/actions/authActions";
import { set_value_layer } from "../../App/actions/layerActions";
import { is_has_license_basic_or_license_sharing } from "../../App/actions/filter_license";
import { get_layer_by_share_link } from "../../App/actions/sharedLinkActions";
import { activities_timeseries } from "../../App/actions/activities";

/*FUNCTION*/
import decode_params_to_object from "../../App/validation/decode_params_to_object";
import getStatusMember from "../../App/validation/get-status-member";

/*DATA*/
import dict from "../../Data/dict.json";
import Modal from "../../Components/common_modal/Modal";

/*CONST*/
const sidebar_closed = 70;

const PARENT_MAP = ({
  pageMode,
  match,
  history, // <-- Added history prop for React Router navigation
  auth,
  project,
  layer,
  properties,
  loading_reducer,
  getUserPaymentList,
  clearLayer,
  getGroups,
  getGroupsProject,
  finishGenangan,
  clearProject,
  getDetailLayerById,
  set_value_properties,
  get_detail_many_layer,
  get_project_only,
  set_value_layer,
  is_has_license_basic_or_license_sharing,
  get_layer_by_share_link,
  activities_timeseries,
}) => {
  const mode_page = pageMode;
  const language = localStorage?.language || "ina";
  const geo_project_link = match?.params?.geo_project_link;
  const { is_mobile, still_loading_layer, still_loading_many_layer } =
    properties;

  const [showModal, setShowModal] = useState(false);

  // Create refs to track the user's intent without triggering re-renders
  const modalIsOpenRef = useRef(false);
  const intentToLeaveRef = useRef(false);

  // Keep the ref synced with your state
  useEffect(() => {
    modalIsOpenRef.current = showModal;
  }, [showModal]);

  useEffect(() => {
    if (mode_page === "editor") {
      // 1. Push a state when they enter the editor so we have something to pop
      window.history.pushState(null, null, window.location.pathname);

      const handlePopState = (event) => {
        // If they explicitly clicked "Keluar", ignore this event and let them leave
        if (intentToLeaveRef.current) return;

        // If the modal is already open, don't trap them in a loop
        if (modalIsOpenRef.current) return;

        // Push state AGAIN to replace the one they just popped, trapping them here
        window.history.pushState(null, null, window.location.pathname);
        setShowModal(true);
      };

      window.addEventListener("popstate", handlePopState);
      return () => window.removeEventListener("popstate", handlePopState);
    }
  }, [mode_page]);

  const handleLeave = () => {
    intentToLeaveRef.current = true; // Tell our listener to ignore the cleanup
    setShowModal(false);

    // Route the user directly to the dashboard
    if (history) {
      history.push("/dashboard");
    } else {
      // Fallback just in case React Router's history isn't available
      window.location.href = "/dashboard";
    }
  };

  const handleStay = () => {
    setShowModal(false);
    // You DO NOT need to pushState here anymore, because handlePopState already did it!
  };

  useEffect(() => {
    set_value_properties({ key: "mode_map", value: mode_page });
    set_value_layer({ key: "page_layer_mode", value: mode_page });
    return () => {
      set_value_properties({ key: "mode_map", value: "" });
      set_value_layer({ key: "page_layer_mode", value: "" });
    };
  }, [mode_page, set_value_properties, set_value_layer]);

  useEffect(() => {
    activities_timeseries("view");
  }, [activities_timeseries]);

  useEffect(() => {
    if (is_mobile) {
      set_value_properties({ key: "is_mobile_close", value: true });
      set_value_properties({ key: "sidebar_height", value: sidebar_closed });
    }
    set_value_properties({ key: "sidebar_right_status", value: true });
    set_value_properties({ key: "get_layer_list_status", value: "" });
    if (geo_project_link === "share") {
      const search = window?.location?.search?.substring(1);
      let object_param = {};
      let share_link;
      if (search) {
        object_param = JSON.parse(
          '{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}',
          function (key, value) {
            return key === "" ? value : decodeURIComponent(value);
          },
        );
        share_link = object_param?.link;
        get_layer_by_share_link({ link: share_link });
      }
    } else {
      set_value_properties({
        key: "geo_project_link",
        value: geo_project_link,
      });
      get_project_only(geo_project_link);
      getGroupsProject(geo_project_link);
      set_value_properties({ key: "folder_list_active", value: [] });
      getUserPaymentList();
      getGroups();
    }
  }, [
    geo_project_link,
    set_value_properties,
    get_project_only,
    getGroupsProject,
    getUserPaymentList,
    getGroups,
    is_mobile,
    get_layer_by_share_link,
  ]);

  useEffect(() => {
    return () => {
      clearLayer();
      clearProject();
      finishGenangan();
      set_value_layer({ key: "tableStatus", value: false });
      set_value_properties({ key: "get_layer_list_status", value: "" });
    };
  }, [
    clearLayer,
    clearProject,
    finishGenangan,
    set_value_layer,
    set_value_properties,
  ]);

  const prevGetLayerListStatusRef = useRef();

  useEffect(() => {
    const currentStatus = properties.get_layer_list_status;
    const prevStatus = prevGetLayerListStatusRef.current;

    if (currentStatus === "done" && prevStatus !== currentStatus) {
      const { geo_project } = project;
      const { geo_layer_list } = layer;
      let layer_list_load_first = geo_project?.layer_list_load_first || [];
      layer_list_load_first = layer_list_load_first.filter((item) => !!item);

      const params = window?.location?.search?.substring(1);
      let object_params = {};
      let layer_id;
      let sidebar_right_status = false;

      if (params) {
        object_params = decode_params_to_object(params);
        layer_id = object_params?.layer_id;
        sidebar_right_status =
          object_params?.sidebar_right_status === "true" ? true : false;
      }

      if (layer_id) {
        const folder_id = geo_layer_list.find(
          (item) => item.geo_layer._id === layer_id,
        )?.folder;
        const geoLayer = geo_layer_list.find(
          (item) => item.geo_layer._id === layer_id,
        )?.geo_layer;
        const features = geoLayer?.geojson?.features || [];
        if (!features?.length && !still_loading_layer) {
          getDetailLayerById({
            geo_layer_id: layer_id,
            geo_project_id: geo_project._id,
            flyStatus: true,
            folder_id,
          });
        }
      }

      if (layer_list_load_first.length > 0 && !still_loading_many_layer) {
        get_detail_many_layer({
          layer_list: layer_list_load_first,
          geo_project_id: geo_project._id,
          folder_id: "",
        });
      }

      if (sidebar_right_status === true) {
        set_value_properties({ key: "sidebar_right_status", value: true });
      }
    }
    prevGetLayerListStatusRef.current = currentStatus;
  }, [
    properties.get_layer_list_status,
    project,
    layer,
    getDetailLayerById,
    set_value_properties,
    get_detail_many_layer,
    still_loading_layer,
    still_loading_many_layer,
  ]);

  const geo_layer_link =
    match?.params?.geo_layer_link !== "no_layer"
      ? match?.params?.geo_layer_link
      : "";
  const mode = match?.params?.mode;
  const { user } = auth;
  const { loadingProcess, itemLoading, chatStatus, realtimeStatus } = layer;
  const { geo_project } = project;
  const { loading_item_array } = loading_reducer;

  let status_user = "guest";
  const groups = geo_project?.groups || [];

  if (
    !!user?._id &&
    !!geo_project?.user?._id &&
    user?._id === geo_project?.user?._id
  ) {
    status_user = "creator";
  } else if (user?._id) {
    status_user = getStatusMember(groups, user?._id);
  }

  let content;

  const isFetchingCoreData =
    loading_item_array.includes("get_project_only") ||
    loading_item_array.includes("get_layer_by_share_link") ||
    loading_item_array.includes("optimized_get_user_license") ||
    loading_item_array.includes("verify_license") ||
    loading_item_array.includes("getUserPaymentList") ||
    loading_item_array.includes("getUserFromToken") ||
    loading_item_array.includes("verify_license_user") ||
    loading_item_array.includes("verify_license_group") ||
    loading_item_array.includes("verify_license_sharing") ||
    loading_item_array.includes("verify_license") ||
    loading_item_array.includes("getGroupsProject") ||
    loading_item_array.includes("getGroups") ||
    loading_item_array.includes("get_collaborator") ||
    loading_item_array.includes("getProjectDetailByLink");

  if (isFetchingCoreData) {
    content = (
      <main
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          backgroundColor: "#f8f9fc",
        }}
      >
        <section
          style={{
            width: "350px",
            maxWidth: "90%",
            padding: "40px",
            backgroundColor: "#ffffff",
            borderRadius: "16px",
            boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "24px",
          }}
        >
          <div className="center_perfect">
            <div
              className="modern-map-spinner"
              style={{ width: "80px", height: "80px" }}
            />
            <img
              className="floating"
              src={icon_geomapid}
              style={{ width: "40px", height: "40px", position: "absolute" }}
              alt="GEOMAPID"
            />
          </div>
          <p
            style={{
              margin: 0,
              fontWeight: "600",
              color: "#4a5568",
              fontSize: "15px",
              fontFamily: "system-ui, -apple-system, sans-serif",
              letterSpacing: "0.3px",
            }}
          >
            Loading Map...
          </p>
          <style>{`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
            .modern-map-spinner {
              width: 42px;
              height: 42px;
              // border: 4px solid #edf2f7;
              // border-top: 4px solid #4299e1;
              border-radius: 50%;
              background: conic-gradient(
                from 0deg,
                
                /* Navy */
                #1E6098 0deg,
                #2E74B3 60deg,
                
                /* Blue */
                #5198D2 120deg,
                #6AAAE0 180deg,
                
                /* Green */
                #7CB542 240deg,
                #98CC5D 300deg,
                
                /* kembali ke awal */
                #1E6098 360deg
              );
              animation: spin 1s linear infinite;
            }
            .modern-map-spinner::before {
              content: "";
              position: absolute;
              inset: 4px;
              background: white; /* sesuaikan background */
              border-radius: 50%;
            }
          `}</style>
        </section>
      </main>
    );
  } else if (geo_project.isPublic && mode_page === "viewer") {
    content = <MAP_EDITOR geo_layer_link={geo_layer_link} mode={mode} />;
  } else if (!is_has_license_basic_or_license_sharing()) {
    content = <NO_LICENSE_HANDLE />;
  } else if (
    mode_page === "viewer" &&
    ["creator", "admin", "contributor", "viewer"].includes(status_user)
  ) {
    content = <MAP_EDITOR geo_layer_link={geo_layer_link} mode={mode} />;
  } else if (
    mode_page === "editor" &&
    ["creator", "admin", "contributor"].includes(status_user)
  ) {
    content = <MAP_EDITOR geo_layer_link={geo_layer_link} mode={mode} />;
  } else if (
    mode_page === "editor" &&
    ["viewer", "guest"].includes(status_user)
  ) {
    content = <COLLAB_BLOCK_EDITOR />;
  } else if (mode_page === "viewer" && ["guest"].includes(status_user)) {
    content = <COLLAB_BLOCK_VIEWER />;
  } else {
    content = <COLLAB_BLOCK_VIEWER />;
  }

  let textLoading = itemLoading || "Saving";
  switch (itemLoading) {
    case "createLayer":
      textLoading = dict["Creating layer"][language];
      break;
    case "importLayer":
      textLoading = dict["Importing layer"][language];
      break;
    case "uploadLayer":
      textLoading = dict["Importing layer"][language];
      break;
    case "edit_general":
      textLoading = dict["Saving changes"][language];
      break;
    case "editAllFields":
      textLoading = dict["Saving changes"][language];
      break;
    case "editLayerForm":
      textLoading = dict["Saving changes"][language];
      break;
    case "pushFeature":
      textLoading = dict["Adding feature"][language];
      break;
    case "push_project_attach":
      textLoading = dict["Attaching layer"][language];
      break;
    case "delete_project_attach":
      textLoading = dict["Deleting attached layer"][language];
      break;
    case "edit_geometry":
      textLoading = dict["Saving geometry changes"][language];
      break;
    case "edit_properties":
      textLoading = dict["Saving attribute value"][language];
      break;
    case "delete_feature":
      textLoading = dict["Deleting"][language];
      break;
    case "hide_feature":
      textLoading = dict["Hiding feature"][language];
      break;
    case "push_field":
      textLoading = dict["Adding column"][language];
      break;
    case "editField":
      textLoading = dict["Saving column"][language];
      break;
    case "deleteField":
      textLoading = dict["Deleting column"][language];
      break;
    case "delete_layer":
      textLoading = dict["Deleting layer"][language];
      break;
    case "get_detail":
      textLoading = dict["Getting GIS data"][language];
      break;
    case "genangan":
      textLoading = dict["Running the inundation algorithm"][language];
      break;
    case "deleteFieldForm":
      textLoading = dict["Deleting table columns"][language];
      break;
    case "move_layers_into_any_folder":
      textLoading = dict["Moving layers"][language];
      break;
    case "delete_layers_bulk":
      textLoading = dict["Deleting layers"][language];
      break;
    case "push_child_array":
      textLoading = "Menambahkan baris";
      break;
    case "edit_child_cell":
      textLoading = "Menyimpan perubahan";
      break;
    case "push_features":
      textLoading = "Menyimpan layer";
      break;
    default:
      textLoading = itemLoading;
      break;
  }

  const isLoadingConditionMet =
    !!textLoading && !chatStatus && !realtimeStatus && loadingProcess;

  const [renderLoading, setRenderLoading] = useState(isLoadingConditionMet);
  const [isPillVisible, setIsPillVisible] = useState(false);
  const [showText, setShowText] = useState(true);
  const [isCircle, setIsCircle] = useState(false);
  const [isDisappearing, setIsDisappearing] = useState(false);

  const showStartTimeRef = useRef(0);
  const MIN_DISPLAY_TIME_MS = 400;

  useEffect(() => {
    let timeouts = [];
    const addTimeout = (fn, delay) => {
      const t = setTimeout(fn, delay);
      timeouts.push(t);
      return t;
    };

    if (isLoadingConditionMet) {
      showStartTimeRef.current = Date.now();
      setRenderLoading(true);
      setShowText(true);
      setIsCircle(false);
      setIsDisappearing(false);
      addTimeout(() => setIsPillVisible(true), 10);
    } else {
      const elapsedTime = Date.now() - showStartTimeRef.current;
      const timeToWait = Math.max(0, MIN_DISPLAY_TIME_MS - elapsedTime);

      addTimeout(() => {
        setShowText(false);
        addTimeout(() => {
          setIsCircle(true);
        }, 100);
        addTimeout(() => {
          setIsDisappearing(true);
        }, 250);
        addTimeout(() => {
          setIsPillVisible(false);
          setRenderLoading(false);
        }, 400);
      }, timeToWait);
    }

    return () => timeouts.forEach(clearTimeout);
  }, [isLoadingConditionMet]);

  return (
    <div>
      {renderLoading && (
        <div
          className="background_black"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "34px",
            minWidth: isCircle ? "34px" : "141px",
            maxWidth: isCircle ? "34px" : "300px",
            padding: isCircle ? "0" : "0 15px",
            boxSizing: "border-box",
            textAlign: "center",
            zIndex: "9999",
            position: "fixed",
            top: "5px",
            left: "50%",
            fontSize: "13px",
            fontWeight: "500",
            borderRadius: "999px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            pointerEvents: "none",
            overflow: "hidden",
            opacity: isDisappearing ? 0 : isPillVisible ? 1 : 0,
            transform: isDisappearing
              ? "translateX(-50%) translateY(-40px) scale(0)"
              : isPillVisible
                ? "translateX(-50%) translateY(0) scale(1)"
                : "translateX(-50%) translateY(-20px) scale(0.8)",
            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
          }}
        >
          <span
            style={{
              opacity: showText ? 1 : 0,
              transition: "opacity 0.1s ease",
              whiteSpace: "nowrap",
              display: "inline-block",
            }}
          >
            {textLoading}
          </span>
        </div>
      )}

      {content}

      {showModal && mode_page === "editor" && (
        <Modal
          modalSize="small"
          isOpen={showModal}
          onClose={() => setShowModal(false)}
          disableBackHijack={true}
        >
          <div className="box-body">
            <p>Yakin mau kembali?</p>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "10px",
                marginTop: "20px",
              }}
            >
              <button className="button background_grey" onClick={handleStay}>
                Tetap di sini
              </button>
              <button className="button background_red" onClick={handleLeave}>
                Keluar
              </button>
            </div>
          </div>
        </Modal>
      )}

      <style>{`
      body{
        padding-top: 0px;
        overflow-y: hidden;
      }
      #navbarDefault{ visibility: hidden;}
      .top_nav{ visibility: hidden;}
      .sidebar_home{ visibility: hidden;}
    `}</style>
    </div>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  payment: state.payment,
  project: state.project,
  layer: state.layer,
  properties: state.properties,
  license_reducer: state.license_reducer,
  loading_reducer: state.loading_reducer,
});

const ConnectedParentMap = connect(mapStateToProps, {
  getUserPaymentList,
  clearLayer,
  getGroups,
  getGroupsProject,
  finishGenangan,
  clearProject,
  set_value_user,
  getDetailLayerById,
  realtime_update,
  set_value_properties,
  get_detail_many_layer,
  get_project_only,
  set_value_layer,
  is_has_license_basic_or_license_sharing,
  get_layer_by_share_link,
  activities_timeseries,
})(PARENT_MAP);

export const PARENT_MAP_EDITOR = (props) => (
  <ConnectedParentMap {...props} pageMode="editor" />
);
export const PARENT_MAP_VIEWER = (props) => (
  <ConnectedParentMap {...props} pageMode="viewer" />
);
